import GameModel from '../../../vendor_core/core/src/model/GameModel';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import PreloadView from "../../../vendor_core/core/src/views/PreloadView";

export default class TRWPreloadView extends PreloadView {
    constructor() {
        super();
        let isChinese: boolean = (GameModel.lang == "zh-cn" || GameModel.lang == "zh-tw");
        const scene =  ViewManager.getLayer(DefaultLayers.Preloader).getCurrentScene();
        const anim: any = scene.spineAnimations.get("logo");
        anim.skeleton.setSkinByName(isChinese ? "chinese" : "english");
        anim.play("loop_loading");
    }
}
